import apiClient from './apiService';

export interface CapaFeedbackItem {
    id: number;
    name: string;
    description?: string;
    feedback_text?: string;
    doer_comment?: string | null;
    due_date?: string | null;
    status: string;
    priority?: string | null;
    doer_id?: number | null;
    validator_id?: number | null;
    approver_id?: number | null;
    issue_id?: number | null;
    issue_code?: string;
    issue_name?: string;
    doer_name?: string;
    validator_name?: string;
    approver_name?: string;
    submitted_on?: string | null;
}

export const capaFeedbackService = {
    list: async (params?: { q?: string; limit?: number; offset?: number }): Promise<{ data: CapaFeedbackItem[]; total: number }> => {
        const resp = await apiClient.get('/api/v1/cap/feedback', { params });
        const data: CapaFeedbackItem[] = resp.data?.data ?? [];
        return { data, total: resp.data?.total ?? data.length };
    },
    approve: async (taskId: number): Promise<{ task_id: number; status: string }> => {
        const resp = await apiClient.post(`/api/v1/cap/feedback/${taskId}/approve`);
        return resp.data?.data;
    },
    reject: async (taskId: number, comment: string): Promise<{ task_id: number; status: string }> => {
        const resp = await apiClient.post(`/api/v1/cap/feedback/${taskId}/reject`, { comment });
        return resp.data?.data;
    },
};
